// extracted by mini-css-extract-plugin
module.exports = {"image":"CatalogItemImage__image","imageBlock":"CatalogItemImage__imageBlock"};